import styled, { css } from 'styled-components';

export const IconWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => !['showButton'].includes(prop),
})`
  z-index: -1;
  opacity: 0;
  width: 60px;
  height: 60px;
  border: 2px solid ${({ theme }) => theme.colors.title};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.bgPrimary};
  position: -webkit-sticky;
  position: sticky;
  margin: 0 38px -38px auto;
  bottom: 20px; /* when sticky */
  right: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  //box-shadow: 0 0 4px 1px ${({ theme }) => theme.colors.black30};
  transition: ${(props) => props.theme.constants.transitionBase};

  @media ${(props) => props.theme.device.mobileL} {
    width: 44px;
    height: 44px;
    margin: 0 14px -31px auto;
  }

  &:hover {
    svg {
      position: relative;
      bottom: 5px;
    }
  }

  ${(props) =>
    props.showButton &&
    css`
      opacity: 1;
      z-index: 10;
    `}

  svg {
    position: relative;
    bottom: 0;
    fill: ${({ theme }) => theme.colors.title};
  }
`;
